import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import { Loader } from "../../atoms/Loader";
import {
  getAllSetting,
  deleteSetting,
} from "../../../APICalling/ServiceAPICalling";
import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";
import CreateNewSettingModal from "./CreateNewSettingModal";
import EditSetting from "./EditSetting";
import DeleteModuleSetting from "./DeleteModuleSetting";
import workdriveIcon from "../../../Images/Zoho Workdrive.png";
import sharepointIcon from "../../../Images/SharePoint.png";

function ModuleSetting(props) {
  const {
    children,
    tabIndex,
    index,
    orgid,
    apikey,
    datacenterurl,
    datacenter,
    zuid,
    zapikey,
    ...other
  } = props;

  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [settings, setSettings] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState(null);

  const getAllSettings = async ({ headers, params }) => {
    try {
      const settingData = await getAllSetting({ headers, params });

      return settingData?.data || [];
    } catch (error) {
      return [];
    }
  };

  const handleCreateSetting = () => {
    try {
    } catch (error) {
      return [];
    }
  };

  const checkData = async (cb) => {
    let params = { settingType: "moduleCron" };
    let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
    const settings = await getAllSettings({ headers, params });

    const returnData = {
      bool: true,
      settings: settings,
    };
    cb(returnData);
  };

  const deleteSettingById = async (settingId) => {
    try {
      let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
      const settingResp = await deleteSetting({ settingId, headers });

      setReload((prev) => !prev);
    } catch (error) {}
  };

  useEffect(() => {
    if (orgid && apikey && tabIndex === index) {
      setLoading((prev) => true);
      checkData((returnData) => {
        setSettings((prev) => returnData?.settings);
        setLoading((prev) => false);
      });
    }
  }, [tabIndex, reload]);

  if (tabIndex != index) {
    return <></>;
  }

  if (loading) {
    return <Loader />;
  }

  if (!orgid || !apikey || !datacenterurl) {
    return (
      <>
        Some of the data are missing
        {orgid}-{apikey}-{datacenterurl}
      </>
    );
  }

  return (
    <Box
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={
        {
          // maxWidth: "80%",
          // py: 2,
          // px: 2,
        }
      }
    >
      <Box px={1} py={1}>
        {/* Header and Add Button */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Module Setting
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This screen allows users to configure which CRM modules are linked
              to their connected storage services for automatic attachment
              backups.
            </Typography>
          </Box>

          <CreateNewSettingModal
            service={"Test"}
            handleCreateSetting={handleCreateSetting}
            setReload={setReload}
            orgid={orgid}
            apikey={apikey}
            datacenterurl={datacenterurl}
            datacenter={datacenter}
            zuid={zuid}
          />
        </Box>

        {/* Settings Grid */}
        <Box display="flex" flexWrap="wrap" gap={2}>
          {settings?.map((setting, index) => {
            const parsedSchema = JSON.parse(setting?.setting_schema);
            const serviceLabel = parsedSchema?.service?.displayLabel;
            const serviceIcon =
              serviceLabel === "Zoho Work Drive"
                ? workdriveIcon
                : serviceLabel === "Share Point"
                ? sharepointIcon
                : "https://via.placeholder.com/40";

            return (
              <Paper
                key={index}
                sx={{
                  width: 240,
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                }}
                elevation={0}
              >
                {/* Logo Section */}
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#f5faff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <img
                    src={serviceIcon}
                    alt="service icon"
                    style={{ width: 52, height: 52 }}
                  />
                </Box>

                {/* Service Name */}
                <Typography fontWeight={600} mb={0.5}>
                  {serviceLabel}
                </Typography>

                {/* Module and Field Info */}
                <Typography variant="body2" color="text.secondary">
                  {parsedSchema?.module?.displayLabel}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  {parsedSchema?.modulefield?.fieldDisplayLabel}
                </Typography>

                {/* Action Buttons */}
                <Box
                  display="flex"
                  justifyContent="center"
                  gap={1}
                  mt="auto"
                  sx={{ width: "100%", pt: 2 }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => {
                      let jsonObject = {
                        ...setting,
                        setting_schema: parsedSchema,
                      };
                      setSelectedSetting((prev) => jsonObject);
                    }}
                    sx={{ textTransform: "none", width: "100%" }}
                  >
                    Edit
                  </Button>
                  <DeleteModuleSetting
                    service={JSON.parse(setting?.setting_schema)}
                    handleRevokeService={() => {
                      deleteSettingById(setting?.setting_id);
                    }}
                  />
                </Box>
              </Paper>
            );
          })}
        </Box>

        {/* Edit Modal */}
        {selectedSetting && (
          <EditSetting
            service={"Test"}
            handleCreateSetting={handleCreateSetting}
            selectedSetting={selectedSetting}
            setSelectedSetting={setSelectedSetting}
            orgid={orgid}
            apikey={apikey}
            datacenterurl={datacenterurl}
            datacenter={datacenter}
            zuid={zuid}
            setReload={setReload}
          />
        )}
      </Box>
    </Box>
  );
}

export default ModuleSetting;
